export const CAPACITOR_EVENT = {
  SAFE_AREA_CHANGED: 'safeAreaChanged',
  KEYBOARD_WILL_SHOW: 'keyboardWillShow',
  KEYBOARD_WILL_HIDE: 'keyboardWillHide',
} as const
